var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h802v602H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.31 53.186l29.613 29.615a4.455 4.455 0 003.174 1.31 4.457 4.457 0 003.174-1.31l2.69-2.69a4.455 4.455 0 001.31-3.173 4.55 4.55 0 00-1.31-3.21L31.682 56.413h54.89c2.474 0 4.43-1.937 4.43-4.413v-3.802c0-2.476-1.956-4.608-4.43-4.608H31.486L48.96 26.178a4.39 4.39 0 001.31-3.144c0-1.2-.465-2.313-1.31-3.158l-2.689-2.68a4.451 4.451 0 00-3.174-1.307 4.457 4.457 0 00-3.173 1.312L10.308 46.816a4.458 4.458 0 00-1.31 3.183 4.457 4.457 0 001.31 3.187h.001z",
    stroke: "null"
  })));
};
export default SvgArrowLeft;